module.exports = __webpack_public_path__ + "img/avatar.d3927136.png";